<template>
  <div class="affirmation">
    <transition name="description"
                enter-active-class="animated fadeIn"
                leave-active-class="animated fadeOut">

      <div class="leftRightMargin">
        <BeautifulOrderedList classes="title3" v-if="showAffirmationDescription && withMirror" :array="withMirrorList" color="blue"></BeautifulOrderedList>
        <BeautifulOrderedList classes="title3" v-if="showAffirmationDescription && !withMirror" :array="withoutMirrorList" color="blue"></BeautifulOrderedList>
      </div>
    </transition>
    <div class="content">

      <transition name="description"
                  enter-active-class="animated fadeIn"
                  leave-active-class="animated fadeOut">
        <div v-if="showAffirmationText" class="text title1 text-center card shadow">{{ affirmationText }}</div>
      </transition>
    </div>
    <div class="controls text-center">
      <div style="text-align: center; margin-bottom: 62px;">
        <div class="repeatStep title3">
          Repeat it 3-4 times, focusing on the meaning of each word
        </div>
        <div v-if="buttonText" class="primaryButton light" @click="finish">{{ buttonText }}</div>
      </div>
    </div>
  </div>
</template>

<script>

  import {randomItem} from "@/util/randomItem";
  import {sleep} from "@/util/sleep";
  import PageSecondaryText from "@/components/text/PageSecondaryText";
  import BeautifulOrderedList from "@/components/lists/BeautifulOrderedList";

  export default {
    name: 'Affirmation',
    components: {BeautifulOrderedList, PageSecondaryText},
    props: ['variants', 'buttonText', 'withMirror'],
    data() {
      return {
        showAffirmationDescription: false,
        showAffirmationText: false,
        withMirrorList: [
          `Stand in front of a mirror and look yourself in the eyes`,
          `Smile, if it feels natural`,
          `Say this phrase to yourself slowly and clearly`
        ],
        withoutMirrorList: [
          `Close your eyes`,
          `Smile, if it feels natural`,
          `Say this phrase to yourself slowly and clearly`
        ]
      }
    },

    computed: {
      affirmationText: function() {
        return randomItem(this.variants)
      }
    },

    methods: {
      finish: function() {
        this.$emit('finish');
      }
    },

    async created() {
      await sleep(50);
      this.showAffirmationDescription = true;
      this.showAffirmationText = true;

    }
  }
</script>

<style lang="scss">
  @import "src/assets/scss/variables";

  .affirmation {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    height: 100%;

    .repeatStep {
      padding: $bigPadding;
    }

    .description {
      margin-left: $primaryMargin;
      margin-right: $primaryMargin;
      text-align: center;
    }

    .content {

    }
  }


</style>
